import { render, staticRenderFns } from "./canvasName.vue?vue&type=template&id=149ad322&scoped=true&"
import script from "./canvasName.vue?vue&type=script&lang=js&"
export * from "./canvasName.vue?vue&type=script&lang=js&"
import style0 from "./canvasName.vue?vue&type=style&index=0&id=149ad322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ad322",
  null
  
)

export default component.exports